module.exports = __webpack_public_path__ + "img/micoma_logo_w.b300cba6.png";